import { createContext } from 'react';

const CoreAuthContext = createContext({});

export default CoreAuthContext;
